import Model, { attr, belongsTo } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type School from 'district-ui-client/models/school'
import type Teacher from 'district-ui-client/models/teacher'
import type StringTransform from 'district-ui-client/transforms/string'

export default class SubscriptionCoordinator extends Model {
  @attr<StringTransform>('string') declare product: string

  @belongsTo<School>('school', { async: false, inverse: 'subscriptionCoordinators' }) declare school?: School

  @belongsTo<Teacher>('teacher', { async: false, inverse: 'subscriptionCoordinators' }) declare teacher?: Teacher

  isForSubscriptionType(subscriptionType: string) {
    return this.product === subscriptionType
  }

  [Type] = 'subscription-coordinator' as const
}
